module.exports = __webpack_public_path__ + "static/media/user4.dc7f1faf.gif";